// extracted by mini-css-extract-plugin
module.exports = {"alert":"notificationmenuitem_alert__3agfr","item":"notificationmenuitem_item__2QAg3"};